import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Carousel } from "@faire/retailer-visitor-shared/components/Carousel/Carousel";
import { ILeanBrandTile } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/ILeanBrandTileAdapters";
import { LeanBrandTileRendererForCarousel } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/LeanBrandTileRendererForCarousel";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { useQuery as useInsiderCarouselBrandsQuery } from "@faire/web-api--source/api/retailer/insider/brands/carousel/get-hooks";
import { trackInsiderIntlMarketingPageBrandCarouselScroll } from "@faire/web-api--source/events/insider/actionUnknown/intlMarketingPageBrandCarouselScroll";
import { trackInsiderIntlMarketingPageBrandCarouselClick } from "@faire/web-api--source/events/insider/click/intlMarketingPageBrandCarousel";
import { trackInsiderLoggedOutMarketingPageCarouselView } from "@faire/web-api--source/events/insider/view/loggedOutMarketingPageCarousel";
import React from "react";
import styled from "styled-components";
var MIN_TILES = 4;
export var InsiderBrandCarousel = function() {
    var data = useInsiderCarouselBrandsQuery({
        num_brands: 16
    }).data;
    var _data_brands;
    var brands = (_data_brands = data === null || data === void 0 ? void 0 : data.brands) !== null && _data_brands !== void 0 ? _data_brands : [];
    var ref = useDoActionWhenVisible(function() {
        trackInsiderLoggedOutMarketingPageCarouselView();
    });
    if (brands.length < MIN_TILES) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Wrapper, {
        ref: ref,
        children: /*#__PURE__*/ _jsxs(Container, {
            gap: "4x",
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    children: [
                        /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                            mobile: /*#__PURE__*/ _jsx(Spacer, {
                                width: "4x"
                            }),
                            tabletAndAbove: null
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "displaySSerifRegular",
                            children: /*#__PURE__*/ _jsx(Title, {})
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                        mobile: /*#__PURE__*/ _jsx(Carousel, {
                            name: "insider_free_shipping",
                            items: brands,
                            itemsPerSlide: 2,
                            itemGap: 16,
                            renderItem: function(brand, index) {
                                var _brand_token;
                                return /*#__PURE__*/ _jsx(Tile, {
                                    tile: brand,
                                    index: index
                                }, (_brand_token = brand.token) !== null && _brand_token !== void 0 ? _brand_token : index);
                            },
                            buttonsOffsetTop: "calc(50% - 35px)",
                            onScroll: function() {
                                return trackInsiderIntlMarketingPageBrandCarouselScroll();
                            },
                            peekNext: true
                        }),
                        tabletAndAbove: /*#__PURE__*/ _jsx(Carousel, {
                            name: "insider_free_shipping",
                            items: brands,
                            itemsPerSlide: 5,
                            itemGap: 16,
                            renderItem: function(brand, index) {
                                var _brand_token;
                                return /*#__PURE__*/ _jsx(Tile, {
                                    tile: brand,
                                    index: index
                                }, (_brand_token = brand.token) !== null && _brand_token !== void 0 ? _brand_token : index);
                            },
                            buttonsOffsetTop: "calc(50% - 35px)",
                            onScroll: function() {
                                return trackInsiderIntlMarketingPageBrandCarouselScroll();
                            }
                        })
                    })
                })
            ]
        })
    });
};
var Tile = function(props) {
    return /*#__PURE__*/ _jsx(LeanBrandTileRendererForCarousel, {
        leanBrandTile: ILeanBrandTile.fromIBrandTile(props.tile),
        onClick: function() {
            trackInsiderIntlMarketingPageBrandCarouselClick();
        },
        signUpSourceId: "insider_brand_carousel"
    }, props.index);
};
var Title = function() {
    var hasFreeDutyAdvertising = useInsiderFeatureEligibility().hasFreeDutyAdvertising;
    if (hasFreeDutyAdvertising) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "Oe9aq0",
            defaultMessage: [
                {
                    type: 0,
                    value: "Brands you\u2019ll love with free shipping & import duties"
                }
            ]
        });
    }
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "WDWXCv",
        defaultMessage: [
            {
                type: 0,
                value: "Brands you\u2019ll love with free shipping"
            }
        ]
    });
};
var Wrapper = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-d9bb9321-0"
})([
    "width:100%;background-color:",
    ";"
], Core.surface.inverse);
var Container = styled(Column).attrs({
    align: {
        mobileAndAbove: "flex-start",
        tabletAndAbove: "center"
    }
}).withConfig({
    componentId: "sc-d9bb9321-1"
})([
    "width:100%;padding:",
    ";",
    "{max-width:1024px;padding:",
    ";}",
    "{padding:",
    ";}",
    "{max-width:1104px;}"
], getSpacing("5x", 0), responsiveMediaQueries.tabletAndAbove, getSpacing("6x", "7x"), responsiveMediaQueries.desktopAndAbove, getSpacing("8x", "4x"), responsiveMediaQueries.xLargeAndAbove);
